import React from 'react';

import { hasShoppablePurchaseMethod } from '../purchaseMethods';
import type { SerializedVariant } from '../types';
import './SizeSelector.css';

interface SizeSelectorProps {
    variants: SerializedVariant[];
    selectedVariantId: number | null;
    onSelect: (variantId: number) => void;
}

export function SizeSelector({ variants, selectedVariantId, onSelect }: SizeSelectorProps) {
    const variantsWithSize = variants.filter((v) => v.size !== null && v.size !== '');
    if (variantsWithSize.length === 0) { return null; }

    return (
        <div className="pdp-size">
            <div className="pdp-size__label-row">
                <span className="pdp-size__label">size</span>
            </div>
            <div className="pdp-size__tiles" role="radiogroup" aria-label="Size">
                {variantsWithSize.map((v) => {
                    const isActive = v.id === selectedVariantId;
                    const shoppable = hasShoppablePurchaseMethod(v);
                    return (
                        <button
                            key={v.id}
                            type="button"
                            role="radio"
                            aria-checked={isActive}
                            disabled={!shoppable}
                            className={`pdp-size__tile${isActive ? ' pdp-size__tile--active' : ''}${shoppable ? '' : ' pdp-size__tile--out'}`}
                            onClick={() => onSelect(v.id)}
                        >
                            {v.size}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
